import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { originalEmailActions } from '../actions/originalEmail';
import PrinterFriendly from '../components/PrinterFriendly';
const mapStateToProps = (state) => {
    return {
        originalEmail: state.originalEmail,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        originalEmailCloseModal: bindActionToPromise(dispatch, originalEmailActions.originalEmailCloseModal),
        originalEmailHtmlGetByType: bindActionToPromise(dispatch, originalEmailActions.originalEmailHtmlGetByType),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PrinterFriendly);
